// RichTextEditor.js (Child Component)
import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Loading from "../Loading";
import tw from "tailwind-styled-components";
import { SubmitBtn } from "../Styles/InputStyles";

// Define Quill modules (toolbar)
const modules = {
  toolbar: [
    [{ header: [1, 2, false] }], // Headings
    ["bold", "italic", "underline"], // Text styling
    [{ list: "ordered" }, { list: "bullet" }], // Lists
    [{ align: [] }], // Alignment options (left, center, right, justify)
    ["link", "image"], // Link & image insertion
    ["clean"], // Remove formatting
  ],
};

// Define Quill formats
const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "list",
  "bullet",
  "align", // Ensures text alignment works
  "link",
  "image",
];

      

const RichTextEditor = ({  value, onChange, onSave, isLoadings, }) => {
    return (
        <div>
            <ReactQuill 
                theme="snow" 
                value={value} 
                onChange={onChange} 
                modules={modules} // Add toolbar customization
                formats={formats} // Ensure formats are supported
                className="h-64 mb-12"
                
            />
            <BtnWrapper>
                <SubmitBtn 
                    type="button" 
                    onClick={onSave} 
                    disabled={isLoadings}
                >
                    {isLoadings ? (
                        <Loading height={22} width={22} noPadding={true} />
                    ) : (
                        "Submit"
                    )}
                </SubmitBtn>
            </BtnWrapper>
        </div>
    );
};

export default RichTextEditor;

const BtnWrapper = tw.div`w-full flex justify-end space-x-10 mt-8`;
